import { useEffect } from "react";
import { useParams, useHistory, Redirect } from "react-router-dom";
import { getCachedData, setTempEntities } from "api/Cache";
import { ViewsActions } from "actions";
import ViewerEvents from "events/ViewerEvents";
import { CircularProgress } from "@mui/material";

let isPushed = false;

export default function Preview() {
    const { entityId } = useParams();
    const cachedData = getCachedData();
    const entities: any = cachedData["entities"];
    const history = useHistory();
    useEffect(() => {
        return () => {
            isPushed = false;
        };
    }, []);

    if (!cachedData.loaded) {
        return <CircularProgress />;
    }

    if (!entityId) {
        return <Redirect to="/views" />;
    }

    let currentProject: any;
    let viewName = "";
    let projectId = "";
    let folder = "0";

    const listEntities: any = entityId.split("+");
    const entityContainer: string = entityId.replace(/\+/gi, " ");
    const id: string = listEntities[0];
    for (var project in entities) {
        var entity = entities[project][id];
        if (entity) {
            viewName = entity.name;
            projectId = project;
            currentProject = entities[project];
            folder = entity["file_folder"];
        }
    }

    if (projectId === "" || !currentProject) {
        return <Redirect to="/views" />;
    }

    if (projectId !== "" && viewName !== "" && !isPushed) {
        isPushed = true;
        ViewsActions.createTempView(viewName, projectId, folder, entityContainer, (view: any) => {
            console.log("created temp view:", view);
            ViewerEvents.view = view;
            ViewerEvents.currentProject = currentProject;
            ViewerEvents.projectId = view ? view["project"] : "";
            setTempEntities(listEntities);
            history.push({
                pathname: "/views/" + view.ID,
                state: {
                    from: history.location.state.from.replace("/app", ""),
                },
            });
        });
    }
    return <CircularProgress />;
}
